import { createSlice } from '@reduxjs/toolkit'
import { logout } from './authSlice';

interface DashboardState {
  showNav: boolean;
  pfcSchedules: any[],
  pfaSchedules: any[],
}

const initialState: DashboardState = {
  showNav: true,
  pfaSchedules: [],
  pfcSchedules: [],
}

export const custodianSlice = createSlice({
  name: 'custodians',
  initialState,
  reducers: {
    toggleSideNav: (state, action) => {
      state.showNav = action.payload;
    },
    addPFASchedules: (state, action) => {
      state.pfaSchedules = action.payload;
    },
    addPFCSchedules: (state, action) => {
      state.pfcSchedules = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(logout, (state) => {
      state = {...initialState};
      return state;
    })
  }
})

export const {
  toggleSideNav,
  addPFASchedules,
  addPFCSchedules,
} = custodianSlice.actions;

export default custodianSlice.reducer;
